import $ from "jquery";

$(document).on('turbolinks:load', function () {
    let timerKey;
    let searchRequestByKey;
    let delay = 1000;
    let $employeeFirstName = $('input#employee_first_name');
    let $employeeLastName = $('input#employee_last_name');
    let $employeeEmail = $('input#employee_email');
    let $employeeFirstNameHidden = $('input#employee_first_name_h');
    let $employeeLastNameHidden = $('input#employee_last_name_h');
    let $employeeEmailHidden = $('input#employee_email_h');
    let employeeKey = document.getElementById('employee_key');
    let $submitButton = $('input#submit_new_user');

    $('#user_role_id').change(function() {
        let roleKey = $(this).find('option:selected').data('key');
        let $fieldsCancelationEmployees = $('.fields_cancelation_employees');

        if (roleKey === 'cancelation_employees') {
            $fieldsCancelationEmployees.removeClass('m--hide');
        } else {
            $fieldsCancelationEmployees.addClass('m--hide');
        }
    });

    let resquestName = (cve_empleado) => {
        if (cve_empleado.length > 0) {
            $submitButton.attr('disabled', 'disabled');
            searchRequestByKey = $.ajax({
                url: `/api/v1/employees/get_name/${cve_empleado}`,
                method: 'GET',
                success: (data) => {
                    console.log(data);
                    if (data !== null) {
                        if (data.duplicated === true) {
                            alert('El empleado indicado ya se encuentra registrado')
                            $employeeFirstName.attr('value', '');
                            $employeeLastName.attr('value', '');
                            $employeeEmail.attr('value', '');
                            $submitButton.attr('disabled', 'disabled');
                        } else {
                            $employeeFirstName.attr('value', data.first_name);
                            $employeeLastName.attr('value', data.last_name);
                            $employeeEmail.attr('value', data.email);
                            $employeeFirstNameHidden.attr('value', data.first_name);
                            $employeeLastNameHidden.attr('value', data.last_name);
                            $employeeEmailHidden.attr('value', data.email);
                            if (data.email !== null){
                                $submitButton.removeAttr('disabled');
                            }
                        }
                    }
                },
                error: (error) => {
                    $employeeFirstName.attr('value', '');
                    $employeeLastName.attr('value', '');
                    $employeeEmail.attr('value', '');
                    $submitButton.attr('disabled', 'disabled');
                },
                complete: () => {
                }
            });
        }
    };

    if (employeeKey !== null) {
        employeeKey.addEventListener('input', function () {
            let cve_empleado = $(this).val();
            $employeeFirstName.attr('value', '');
            $employeeLastName.attr('value', '');
            $employeeEmail.attr('value', '');
            $submitButton.attr('disabled', 'disabled');

            window.clearTimeout(timerKey);
            searchRequestByKey && searchRequestByKey.abort();
            timerKey = window.setTimeout(function () {
                resquestName(cve_empleado);
            }, delay);
        });

        let cve_empleado = $(employeeKey).val();
        if (cve_empleado !== '') {
            resquestName(cve_empleado);
        }
    }

});
